import { Component, OnInit } from '@angular/core';
import {VersionData, VersionService} from "../version/version.service";

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  versionData: VersionData;


  constructor(
    private versionService: VersionService
  ) { }

  ngOnInit(): void {
    this.versionService
      .getVersion()
      .subscribe((versionData) => {
        this.versionData = versionData;

        //enableRum(this.versionData.rumId, this.versionData.rumRegion, this.versionData.rumPoolId);
      });
  }

}
